export default __webpack_public_path__ + "static/media/jana.d31db202.png";